"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuideSectionComponent = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var guidePieSmall_1 = __importDefault(require("./guidePieSmall"));
var guideSectionTableBody_1 = require("./guideSectionTableBody");
var immer_1 = __importDefault(require("immer"));
var GuideSectionTableHeader = function (_a) {
    var section = _a.section, municipalities = _a.municipalities, includeSweden = _a.includeSweden;
    return React.createElement("thead", null,
        React.createElement("tr", null,
            municipalities.map(function (m) {
                return React.createElement("th", { key: m.slug, className: "municipality-column " + (m.editable ? 'edit' : '') },
                    React.createElement("span", null,
                        m.name,
                        React.createElement(guidePieSmall_1.default, { percentage: section.checkedPercentage[m.slug] })));
            }),
            React.createElement("th", { className: "title" },
                React.createElement("div", { className: "flex" },
                    React.createElement("p", { className: "title" }, section.title))),
            includeSweden && React.createElement("th", null,
                React.createElement("div", { className: "last" }, "Sverige"))));
};
var sectionReducer = function (section, _a) {
    var type = _a[0], payload = _a[1];
    try {
        switch (type) {
            case "UPDATE_WITH_RESPONSE": {
                var municipalitySlug_1 = payload.municipalitySlug, gir_1 = payload.guideItemResponse, checkedPercentage_1 = payload.checkedPercentage;
                return immer_1.default(section, function (s) {
                    // response state
                    var gi = s.items.find(function (item) { return item.id === gir_1.guide_item_id; });
                    if (gi) {
                        gi.responses[municipalitySlug_1] = gir_1;
                        gi.statistics = payload.guideItemStatistics;
                    }
                    // section checked percentage
                    s.checkedPercentage[municipalitySlug_1] = checkedPercentage_1;
                });
            }
        }
    }
    catch (e) {
        console.error(e);
        return section;
    }
};
exports.GuideSectionComponent = function (props) {
    var _a = react_1.useReducer(sectionReducer, props.section), section = _a[0], sectionDispatch = _a[1];
    return React.createElement("table", { className: "item", id: section.id.toString() },
        React.createElement(GuideSectionTableHeader, { section: section, municipalities: props.municipalities, includeSweden: false }),
        React.createElement(guideSectionTableBody_1.GuideSectionTableBody, { section: section, municipalities: props.municipalities, includeSweden: false, sectionDispatch: sectionDispatch }));
};
